import React, { useEffect, useState } from "react";
import EditableTable from "./EditableTable.jsx";
import Table from "./Table.jsx";

// Container which includes Table component
// Container height is always maximum space available to allow table to grow and shrink as well.
// if 'maxHeight' is false, container height will be updated based on content height

const TABLE_CONTAINER_MAXIMUM_MIN_HEIGHT = 300;

const TableContainer = ({ bottomMargin = 0, className = "", editable = false, maxHeight = true, defaultMinHeight = 0, ...rest }) => {
  const tableContainerRef = React.useRef();
  const [height, setHeight] = useState();
  const [minHeight, setMinHeight] = useState(maxHeight ? TABLE_CONTAINER_MAXIMUM_MIN_HEIGHT : defaultMinHeight);

  const resize = () => {
    if (maxHeight && tableContainerRef.current) {
      const container = jQuery(tableContainerRef.current);
      setHeight("calc(100vh - " + (bottomMargin + container.offset().top) + "px)");
    }
  };

  const handleResize = (height) => {
    if (tableContainerRef.current) {
      if (maxHeight) {
        setMinHeight(Math.min(height, TABLE_CONTAINER_MAXIMUM_MIN_HEIGHT));
      } else {
        setHeight(height);
      }
    }
  };

  useEffect(() => {
    resize();

    jQuery(window).on("resize", resize);

    return () => {
      jQuery(window).off("resize", resize);
    };
  });

  const props = {
    onClientHeightChange: handleResize,
    ...rest,
  };

  return (
    <div
      ref={tableContainerRef}
      className={`react-table-container ${className}`}
      style={{ height, minHeight }}
    >
      {editable ? <EditableTable {...props} /> : <Table {...props} />}
    </div>
  );
};

export default TableContainer;